import types from '@/vuex/caixa-postal/mutations-types'

const mutations = {
  [types.SET_NUMERO_DOCUMENTO]: (state, payload) => { state.numeroDocumento = payload.numeroDocumento },
  [types.SET_ID_TIPO_DOCUMENTO]: (state, payload) => { state.idTipoDocumento = payload.idTipoDocumento },
  [types.SET_ID_UNIDADE_ATUAL]: (state, payload) => { state.idUnidadeAtual = payload.idUnidadeAtual },
  [types.SET_DATA_ENVIO_INICIO]: (state, payload) => { state.dataEnvioInicio = payload.dataEnvioInicio },
  [types.SET_DATA_ENVIO_FIM]: (state, payload) => { state.dataEnvioFim = payload.dataEnvioFim },
  [types.SET_LISTA_TIPOS_DOCUMENTO]: (state, payload) => { state.listaTiposDocumento = payload.listaTiposDocumento },
  [types.SET_LISTA_UNIDADES_AUTORIZADAS]: (state, payload) => { state.listaUnidadesAutorizadas = payload.listaUnidadesAutorizadas },
  [types.SET_LISTA_DOCUMENTOS]: (state, payload) => { state.listaDocumentos = payload.listaDocumentos },
  [types.SET_BUSCANDO_DOCUMENTOS_CAIXA_POSTAL]: (state, payload) => { state.buscandoDocumentosCaixaPostal = payload.buscandoDocumentosCaixaPostal }
}

export default mutations
